import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';
import APIReportsTab from '../components/Reports/APIReportsTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`reports-tabpanel-${index}`}
      aria-labelledby={`reports-tab-${index}`}
      {...other}
      style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
    >
      {value === index && <Box sx={{ p: 3, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>{children}</Box>}
    </div>
  );
}

const ReportsPage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', height: '100%', p: 3, boxSizing: 'border-box' }}>
      <Paper sx={{ width: '100%', mb: 2, maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label="API Calls" />
            {/* Future tabs can be added here */}
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <APIReportsTab />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default ReportsPage;

